import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	PromoteLoginModalSendResetPasswordLink,
	type PromoteLoginModalSendResetPasswordLinkMutation,
	type PromoteLoginModalSendResetPasswordLinkMutationVariables,
} from './sendResetPasswordLink.graphql';

export async function sendResetPasswordLink(
	input: PromoteLoginModalSendResetPasswordLinkMutationVariables,
	{ gql: { fetch } }: UtilityContext,
): Promise<boolean> {
	const { data } = await fetch<
		PromoteLoginModalSendResetPasswordLinkMutation,
		PromoteLoginModalSendResetPasswordLinkMutationVariables
	>({
		query: PromoteLoginModalSendResetPasswordLink,
		variables: input,
		rejectOnError: true,
	});
	return !!data.sendResetPasswordLink?.success;
}
